<mtx-grid
  style="min-height: 500px"
  [data]="items"
  [length]="resultsLength"
  [pageIndex]="pageIndex"
  [pageSize]="pageSize"
  [columns]="columns"
  [loading]="isLoadingResults"
  [columnResizable]="false"
  [pageOnFront]="false"
  [hideRowSelectionCheckbox]="false"
  [rowHover]="false"
  [rowStriped]="true"
  [showToolbar]="true"
  [toolbarTitle]="'История поиска'"
  [columnHideable]="true"
  [columnSortable]="true"
  [columnPinnable]="false"
  [expandable]="false"
  [showPaginator]="true"
  [pageSizeOptions]="pageSizeOptions"
  [columnMenuButtonText]="'Таблица'"
  [emptyValuePlaceholder]="'Нет данных'"
  (sortChange)="changeSort($event)"
  (selectionChange)="changeSelect($event)"
  (page)="handlePageEvent($event)">
</mtx-grid>
